import ApiService from '@api/api-service';
import * as submitSpinner from '../custom-forms/form-loading';

var VCA = VCA || {};

VCA.UrgentCareVWRForm = (function ($) {
    var ui = {};

    function cacheUI() {
        ui.$VWRInfoWrapper = $('#VWRInfoWrapper');
        ui.$VWRChatWrapper = $('#VWRChatWrapper');
        ui.$VWR = $('#VirtualWaitingRoomLabel');
        ui.$VWRModal = $('#VWRFormModal');
        ui.$VMRForm = $('.uc-vwr-form');
        ui.$VMRFormPhoneNum = $('#VWRPhoneNum');
        ui.$InputEl = $('.uc-vwr-modal input');
        ui.$SelectEl = $('.uc-vwr-modal select');
        ui.$TextAreaEl = $('.uc-vwr-modal textarea');
        ui.$APIErrorMessage = $('.uc-vwr-modal__error-msg');
        ui.$VWRFormSubmitBtn = $('#VWRFormSubmit');
        ui.$VWRChatCTA = $('.vwr-chat-cta'); 

        //helpshift
        ui.$HelpshiftChatBubbleBtn = $('.chat_bubble_button');
        ui.$HelpshiftAlertContainer = $('#alert');
        ui.$HelpshiftCloseBtn = $('#closebtn');
        ui.hospitalId = $('#VWRInfoWrapper').data('hospital-au');
    }

    function bindEvents() {
        ui.$VWRInfoWrapper.on('click', showFormModal);
        ui.$VWRChatWrapper.on('click', initHelpshiftChat);
        ui.$VMRForm.on('submit', validateForm);
        $(ui.$InputEl).on('keyup change', hideErrors);
        $(ui.$SelectEl).on('change', hideErrors);
        $(ui.$TextAreaEl).on('keyup change', hideErrors);
        ui.$HelpshiftChatBubbleBtn.on('click', openHelpshiftChat);
        ui.$HelpshiftAlertContainer.on('click', openHelpshiftChat);
        ui.$HelpshiftCloseBtn.on('click', helpshiftCloseBtn);
        submitSpinner.setupLoadingSpinner(ui.$VWRFormSubmitBtn);
    }

    function hideErrors(e) {
        let el = $(e.currentTarget);
        $(el).removeClass('error');
        $(el).closest('.form-label-group').removeClass('error');
    }

    function showFormModal(e) {
        let el = $(e.target);
        let target = $(e.target)[0];

        if ($(target).hasClass('tooltip-icon') || $(target).hasClass('uc-hero-panel__tooltip')) {
            e.preventDefault();
            return;
        } else {
            let hospitalName = el.data('hospital-name');    
            ui.$VWRModal.modal('show');
    
            //google analytics
            window.dataLayer.push({
                event:'clickevent',
                category:'vca urgent care',
                action:'join vwr',
                label: hospitalName
            });
        }

    }

    function validateForm(evt) {
        evt.preventDefault();
        ui.$APIErrorMessage.hide();
        submitSpinner.startLoadingSpinner(ui.$VWRFormSubmitBtn);

        if (!checkForm()) {
            submitSpinner.stopLoadingSpinner(ui.$VWRFormSubmitBtn);
            return;
        } else  {
            initPostForm();
        }
    }

    function checkForm() {
        let phoneReg = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
        let valid = true;

        $('.uc-vwr-form input').each(function (index) {
            let el = $(this);
            var elmId = el.attr('id');

            if (elmId == 'VWRPhoneNum') {
                let phone = ui.$VMRFormPhoneNum.val();
                if (!phoneReg.test(phone)) {
                    ui.$VMRFormPhoneNum.addClass('error');
                    ui.$VMRFormPhoneNum.closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                    ui.$VMRFormPhoneNum.removeClass('error');
                    ui.$VMRFormPhoneNum.closest('.form-label-group').removeClass('error');
                }
            } else {
                if (el.val() == '') {
                    el.addClass('error');
                    el.closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                    el.removeClass('error');
                    el.closest('.form-label-group').removeClass('error');
                }
            }
        });
        $('.uc-vwr-form select').each(function (index) {
            let el = $(this);
            if (el.val() == '' || el.val() == null) {
                el.addClass('error');
                el.closest('.form-label-group').addClass('error');
                valid = false;
            } else {
                el.removeClass('error');
                el.closest('.form-label-group').removeClass('error');
            }
        });

        $('.uc-vwr-form textarea').each(function (index) {
            let el = $(this);
            if (el.val() == '' || el.val() == null) {
                el.addClass('error');
                el.closest('.form-label-group').addClass('error');
                valid = false;
            } else {
                el.removeClass('error');
                el.closest('.form-label-group').removeClass('error');
            }
        });
        return valid;
    }

    async function initPostForm() {
        const url = '/urgentcare-api/virtualline/waitlistQueueRequest';
        let api = new ApiService(url);

        let $FirstName = ui.$VMRForm.find('#VWRFirstName').val();
        let $LastName = ui.$VMRForm.find('#VWRLastName').val();
        let $PetName = ui.$VMRForm.find('#VWRPetName').val();
        let $PetSpecies = ui.$VMRForm.find('#VWRPetSpecies').val();
        let $IssueType = ui.$VMRForm.find('#VWRIssueType').val();
        let $PhoneNum = ui.$VMRForm.find('#VWRPhoneNum').val();
        let $Description = ui.$VMRForm.find('#VWRBriefDesc').val();

        let payload = {
            "firstName": $FirstName,
            "lastName": $LastName,
            "petName": $PetName,
            "speciesType": $PetSpecies,
            "issueTypeId": $IssueType,
            "phoneNumber": $PhoneNum,
            "briefDesc": $Description,
            "hospitalId": ui.hospitalId,
        }
        
        const searchParams = params => Object.keys(params).map((key) => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
            
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        }

        const { data, success, error } = await api.post(searchParams(payload), axiosConfig);

        if (success) {
            if (data.success) {
                let hospitalName = ui.$VWRInfoWrapper.data('hospital-name');

                //google analytics
                window.dataLayer.push({
                    event:'clickevent',
                    category:'vca urgent care',
                    action:'join vwr success',
                    label: hospitalName
                });

                window.location.href = data.dataRedirect;
            } else {
                if (data.errorMessage !== null || data.errorMessage !== '') {
                    ui.$APIErrorMessage.find('.vwr-form-errormsg').text(data.errorMessage);
                    ui.$APIErrorMessage.show();
                    submitSpinner.stopLoadingSpinner(ui.$VWRFormSubmitBtn);
                }
            }
        } else {
            ui.$APIErrorMessage.find('.vwr-form-errormsg').text(error);
            ui.$APIErrorMessage.show();
            submitSpinner.stopLoadingSpinner(ui.$VWRFormSubmitBtn);
            console.log(`Virtual Waiting Room Form API Error: ${error}`);
        }
    }

    async function loadIssueTypes() {
        const url = `/urgentcare-api/virtualline/issuetypes?id=${ui.hospitalId}`;
        let api = new ApiService(url);

        const { data, success, error } = await api.get();

        if (!success || (error !== null && error !== '')) {
            console.log("API Issue Type Error: ", error);
        } else { 
            let results = data;

            if (results == null || results == undefined) {
                console.log("Error: API results are empty, null, or undefined.");
            } else {
                //SUCCESS
                $(results).each((idx,item) => {
                    let option = `<option value="${item.issueTypeId}" data-mapping-id="${item.issueMappingId}">${item.issueTypeName}</option>`;
                    $('#VWRIssueType').append(option);
                });
            }
        }
    }

    function initHelpshiftChat(e) {
        let el = $(e.currentTarget);
        let hospitalName = el.data('hospital-name');

        Helpshift('show');
        Helpshift('open');

        //google analytics
        window.dataLayer.push({
            event:'clickevent',
            category:'vca urgent care',
            action:'chat',
            label: hospitalName
        });
    }

    function openHelpshiftChat() {
        Helpshift('show');
        Helpshift('open');
    }

    function helpshiftCloseBtn(event) {
        event.stopPropagation();
    }

    function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
    
            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });
    
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    function init() {
        let isUrgentCarePage = $('#is-urgent-care').data('is-uc');

        if (isUrgentCarePage == 'True') {
            waitForElm('.grecaptcha-badge').then((el) => {
                console.log('Element is ready');
                $(el).css('visibility', 'hidden');
            });
        } 

        if (process.env.NODE_ENV !== 'development' && isUrgentCarePage == 'True') {
            cacheUI();
            loadIssueTypes();
            bindEvents();
            $('.back-to-top').css('bottom', '135px');
        }
        

        $(document).on('click', '.header-urgentcare-vwr', () => {
            $('#VWRFormModal').modal('show');
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.UrgentCareVWRForm.init();
});